"use client";

import { useEffect } from "react";

import { IsovTextStack } from "@/components/stencil";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);

    fetch("/api/monitoring/client-error/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error.message,
        digest: error.digest,
        stack: error.stack,
        pathname: window.location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  }, [error]);

  return (
    <html lang="en">
      <body>
        <main>
          <IsovTextStack
            eyebrow="500"
            headline="Error"
            alignment="center"
            className="my-32"
            restricted
          >
            <p>Something went wrong!</p>
            <button onClick={() => reset()}>Try again</button>
          </IsovTextStack>
        </main>
      </body>
    </html>
  );
}
